module.exports = __webpack_public_path__ + "images/9d0bd72e1d0a83ef3a1a1f22609ce364-illu_newBox_SmokeHeatSensor3.png";